package top.wcpe.allincore.ui.runtime.render.layer

import top.wcpe.allincore.layout.engine.Box
import top.wcpe.allincore.ui.runtime.element.UIElement
import top.wcpe.allincore.ui.runtime.render.RenderContext
import top.wcpe.allincore.ui.runtime.render.Renderer
import top.wcpe.allincore.ui.runtime.render.UiRenderBridge
import top.wcpe.allincore.ui.runtime.render.model.RenderLayer

/**
 * 复合渲染器：按层序依次切层并委托给子渲染器。
 *
 * pushLayer/popLayer 确保进入前保存当前层，结束后恢复。
 */
class LayerRenderers(private vararg val entries: LayerRenderer) : Renderer {

    // 多层渲染器，UIRenderer 不应自动切层。
    override fun layer(): RenderLayer? = null

    override fun render(element: UIElement<*>, box: Box, bridge: UiRenderBridge) {
        renderLayers(element, box, bridge, null)
    }

    override fun render(element: UIElement<*>, box: Box, bridge: UiRenderBridge, context: RenderContext) {
        renderLayers(element, box, bridge, context)
    }

    private fun renderLayers(element: UIElement<*>, box: Box, bridge: UiRenderBridge, context: RenderContext?) {
        if (bridge is LayerBufferingBridge) {
            bridge.pushLayer()
            for (entry in entries) {
                bridge.beginLayer(entry.layer)
                dispatch(entry.renderer, element, box, bridge, context)
            }
            bridge.popLayer()
        } else {
            for (entry in entries) {
                dispatch(entry.renderer, element, box, bridge, context)
            }
        }
    }

    /**
     * 转发到子渲染器：有 context 时走新签名，无则走旧签名。
     * 等价于原 Java 以 null context 调用新签名后由默认实现回退旧签名的语义，且避免空 context 误用。
     */
    private fun dispatch(
        renderer: Renderer,
        element: UIElement<*>,
        box: Box,
        bridge: UiRenderBridge,
        context: RenderContext?,
    ) {
        if (context != null) {
            renderer.render(element, box, bridge, context)
        } else {
            renderer.render(element, box, bridge)
        }
    }
}
